// @flow

import React from 'react';
import {AttentionNotice} from 'sail/Notice';
import Box from 'sail/Box';
import {InlineLink} from 'sail/InlineLink';
import {Body} from 'sail/Text';
import {defineMessages, FormattedMessage} from 'react-intl';
import type {IntegrationBuilderType} from './IntegrationBuilder';
import './NarrowScreenWarning.scss';

const messages = defineMessages({
  title: {
    id: 'docsApp.integrationBuilder.narrowScreenWarning.title',
    description: 'Title for narrow screen warning',
    defaultMessage: 'This page is optimized for wider screens.',
  },
  body: {
    id: 'docsApp.integrationBuilder.narrowScreenWarning.body',
    description: 'Body for narrow screen warning',
    defaultMessage:
      'You might prefer the <link>text version of this guide</link>.',
  },
});

type NarrowScreenWarningType = {|
  type: IntegrationBuilderType,
|};

export const NarrowScreenWarning = ({type}: NarrowScreenWarningType) => {
  let href = '';

  switch (type) {
    case 'terminal':
      href = '/docs/terminal/payments/setup-sdk';
      break;
    case 'webhooks':
      href = '/docs/webhooks';
      break;
    case 'billing':
      href = '/docs/billing/subscriptions/build-subscription';
      break;
    default:
      href = '/docs/payments/accept-a-payment';
  }

  return (
    <Box className="NarrowScreenWarning">
      <AttentionNotice
        title={<FormattedMessage {...messages.title} />}
        description={
          <Body>
            <FormattedMessage
              {...messages.body}
              values={{
                link: (str) => <InlineLink href={href}>{str}</InlineLink>,
              }}
            />
          </Body>
        }
      />
    </Box>
  );
};
